import React, { useState, CSSProperties } from 'react'
import { ContainerUpload, FileIndicator } from './styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'

interface UploadFileCustomProps {
    label?: string
    accept?: string
    onFileSelect: (files: File[]) => void
    multiple?: boolean
    style?: CSSProperties
}

export const UploadFileCustom: React.FC<UploadFileCustomProps> = ({
    label = 'Importar arquivo',
    accept = '*',
    onFileSelect,
    multiple = false,
    style,
}) => {
    const [isDragging, setIsDragging] = useState(false)
    // Estado para controlar o que exibir após o upload
    const [selectedFiles, setSelectedFiles] = useState<File[]>([])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const fileArray = Array.from(e.target.files)
            setSelectedFiles(fileArray) // Atualiza visual
            onFileSelect(fileArray)
        }
    }

    const handleDragOver = (e: React.DragEvent<HTMLElement>) => {
        e.preventDefault()
        setIsDragging(true)
    }

    const handleDragLeave = () => {
        setIsDragging(false)
    }

    const handleDrop = (e: React.DragEvent<HTMLElement>) => {
        e.preventDefault()
        setIsDragging(false)
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const fileArray = Array.from(e.dataTransfer.files)
            setSelectedFiles(fileArray) // Atualiza visual
            onFileSelect(fileArray)
        }
    }

    // Helper para decidir o texto do indicativo
    const renderContent = () => {
        if (selectedFiles.length === 0) {
            return (
                <>
                    <FontAwesomeIcon icon={faUpload} />
                    <span>{label}</span>
                </>
            )
        }

        return (
            <FileIndicator>
                <span style={{ maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block' }}>
                    {selectedFiles.length === 1
                        ? selectedFiles[0].name
                        : `${selectedFiles.length} arquivos selecionados`}
                </span>
            </FileIndicator>
        )
    }

    return (
        <ContainerUpload
            as='label'
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={style}
            data-dragging={isDragging}
            data-has-files={selectedFiles.length > 0}
        >
            <input
                type='file'
                accept={accept}
                multiple={multiple}
                onChange={handleInputChange}
                style={{ display: 'none' }}
            />
            {renderContent()}
        </ContainerUpload>
    )
}